import type { Invoice } from "./types";

export function createId() {
  return crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createSampleInvoice(): Invoice {
  const now = new Date().toISOString();

  return {
    id: createId(),
    template: "ledger",
    business: {
      name: "Cloudriver",
      email: "",
      address: "Bld. A2,\nDubai Silicon Oasis,\nDubai,\nUnited Arab Emirates",
    },
    client: {
      name: "Nick AI LLC",
      email: "",
      address: "166 Mercer St, 6B\nNew York, NY 10012",
    },
    details: {
      invoiceNumber: "INV-0022",
      issueDate: "2026-04-28",
      dueDate: "",
      currency: "USD",
    },
    items: [
      {
        id: createId(),
        description: "Platform and application development",
        details: "Full platform build, application implementation, and delivery support.",
        quantity: 1,
        unitPrice: 25000,
      },
    ],
    notes:
      "Please settle the invoice via one of the following payment channels:\n\n1. Wire Transfer",
    paymentInstructions:
      "NAME: CLOUDRIVER\nIBAN: AE600860000009362066510\nBIC/SWIFT: WIOBAEADXXX\nAddress: Etihad Airways Centre 5th Floor, Abu Dhabi, UAE",
    createdAt: now,
    updatedAt: now,
  };
}

export function createBlankInvoice(): Invoice {
  return {
    id: createId(),
    template: "ledger",
    business: { name: "", email: "", address: "" },
    client: { name: "", email: "", address: "" },
    details: {
      invoiceNumber: "INV-0001",
      issueDate: new Date().toISOString().slice(0, 10),
      dueDate: "",
      currency: "USD",
    },
    items: [{ id: createId(), description: "", details: "", quantity: 1, unitPrice: 0 }],
    notes: "",
    paymentInstructions: "",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}
